import React from "react";
import "./Projects.css";

const IDESelect = ({
    advancedAccess,
    onSelect,
    onBack
}) => {

    return (
        <div className="projects-screen">

            <div className="projects-topbar">

                <button
                    type="button"
                    className="back-button"
                    onClick={onBack}
                >
                    ← Back
                </button>

            </div>


            <div className="projects-header">

                <h1>
                    Choose Your IDE
                </h1>

                <p>
                    Choose how you want to build
                    your project.
                </p>

            </div>


            <div className="project-choice-grid">

                {/* Simple IDE */}

                <button
                    type="button"
                    className="project-choice-card"
                    onClick={() => onSelect("simple")}
                >

                    <div className="project-choice-icon">
                        ◇
                    </div>

                    <div className="project-choice-content">

                        <h2>
                            Simple IDE
                        </h2>

                        <p>
                            A simple environment for
                            learning space robotics.
                        </p>

                    </div>

                    <div className="project-choice-arrow">
                        →
                    </div>

                </button>


                {/* Advanced IDE */}

                {advancedAccess && (
                    <button
                        type="button"
                        className="project-choice-card"
                        onClick={() => onSelect("advanced")}
                    >

                        <div className="project-choice-icon">
                            ◇
                        </div>

                        <div className="project-choice-content">

                            <h2>
                                Advanced IDE
                            </h2>

                            <p>
                                Advanced space robotics
                                development with ROS
                                and simulation.
                            </p>

                        </div>

                        <div className="project-choice-arrow">
                            →
                        </div>

                    </button>
                )}

            </div>

        </div>
    );
};

export default IDESelect;